import styled, { css } from "styled-components";

const Link = styled.a`
  width: ${(props) => (props.width ? props.width : "fit-content")};
  height: ${(props) => (props.height ? props.height : "68px")};
  margin-top: ${(props) => (props.marginTop ? props.marginTop : "")};
  margin-bottom: ${(props) => (props.marginBottom ? props.marginBottom : "")};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 40px;
  border-radius: 3px;
  border: none;
  outline: none;
  font-size: 16px;
  background: #fff;
  color: #0b1936;
  font-weight: 400;
  cursor: pointer;
  border: 1px solid #0b1936;
  text-decoration: none;

  @media (max-width: 767.5px) {
    width: ${(props) => (props.widthSm ? props.widthSm : "fit-content")};
    margin: ${(props) => (props.marginSm ? props.marginSm : "")};
  }

  ${(props) =>
    props.primaryBtn &&
    css`
      background: #0b1936;
      color: #fff;
      font-weight: bold;
    `}

  ${(props) =>
    props.secondaryBtn &&
    css`
      background: #fff;
      color: #0b1936;
      font-weight: 400;
      border: 1px solid #0b1936;
    `}
`;

const ButtonLink = (props) => {
  return (
    <Link {...props} target="_blank" rel="noopener noreferrer">
      {props.children}
    </Link>
  );
};

export default ButtonLink;
